import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { first } from '../../../base/common/async.js';
import { onUnexpectedExternalError } from '../../../base/common/errors.js';
import { registerDefaultLanguageCommand } from '../../browser/editorExtensions.js';
import * as modes from '../../common/modes.js';
import { RawContextKey } from '../../../platform/contextkey/common/contextkey.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
export var Context = {
  Visible: new RawContextKey('parameterHintsVisible', false),
  MultipleSignatures: new RawContextKey('parameterHintsMultipleSignatures', false)
};
export function provideSignatureHelp(model, position, context, token) {
  var supports = modes.SignatureHelpProviderRegistry.ordered(model);
  return first(supports.map(function (support) {
    return function () {
      return Promise.resolve(support.provideSignatureHelp(model, position, token, context)).catch(function (e) {
        return onUnexpectedExternalError(e);
      });
    };
  }));
}
registerDefaultLanguageCommand('_executeSignatureHelpProvider', function (model, position, args) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return provideSignatureHelp(model, position, {
              triggerKind: modes.SignatureHelpTriggerKind.Invoke,
              isRetrigger: false,
              triggerCharacter: args['triggerCharacter']
            }, CancellationToken.None);

          case 2:
            result = _context.sent;

            if (result) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", undefined);

          case 5:
            setTimeout(function () {
              return result.dispose();
            }, 0);
            return _context.abrupt("return", result.value);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});